import {
  UTM_KEYS,
  getEntryPoint,
  type EntryPointKey,
  type Utm,
} from "../config/referral";

export interface ReferralConfig {
  partnerId: string;
  chan: string;
  b: string;
  entryPoint: EntryPointKey;
  companies: string[];
  hideHeader: boolean;
  hideFooter: boolean;
  noJivochat: boolean;
  utm: Utm;
}

export type LinkPart = [name: string, value: string];

export interface LinkParts {
  base: string;
  query: LinkPart[];
  hash: LinkPart[];
}

export function sanitizeUtm(value: string): string {
  return value.trim().replace(/\s+/g, "_");
}

/**
 * Порядок параметров фиксирован: ссылка не должна прыгать при перерисовке,
 * иначе партнёр видит «новую» ссылку там, где ничего не менялось.
 */
export function buildLinkParts(config: ReferralConfig, host: string): LinkParts {
  const entry = getEntryPoint(config.entryPoint);
  const query: LinkPart[] = [];

  if (entry.supportsCompanies && config.companies.length) {
    query.push(["companies", config.companies.join(",")]);
  }
  if (config.hideHeader) query.push(["header", "false"]);
  if (config.hideFooter) query.push(["footer", "false"]);
  if (config.noJivochat) query.push(["jivochat", "false"]);

  for (const key of UTM_KEYS) {
    const value = config.utm[key];
    if (value) query.push([key, encodeURIComponent(value)]);
  }

  const hash: LinkPart[] = [["affid", config.partnerId]];
  if (config.b) hash.push(["b", config.b]);
  if (config.chan) hash.push(["chan", encodeURIComponent(config.chan)]);

  return { base: host + entry.path, query, hash };
}

export function partsToUrl(parts: LinkParts): string {
  const query = parts.query.map(([name, value]) => `${name}=${value}`).join("&");
  const hash = parts.hash.map(([name, value]) => `${name}=${value}`).join("&");
  return `${parts.base}${query ? `?${query}` : ""}#${hash}`;
}

export function buildReferralUrl(config: ReferralConfig, host: string): string {
  return partsToUrl(buildLinkParts(config, host));
}

/**
 * Помечает URL как предпросмотр: сайт по этому признаку не подтягивает
 * последний черновик пользователя. В ссылку партнёра флаг не попадает.
 */
export function withPreviewFlag(url: string): string {
  const [base, hash] = url.split("#");
  const separator = base.includes("?") ? "&" : "?";
  return `${base}${separator}preview=true${hash ? `#${hash}` : ""}`;
}
